import { useState, useEffect } from 'react'

export const fetchMaticToUsd = () => {
  const [maticPriceInUSD, setMaticPriceInUSD] = useState(null)

  useEffect(() => {
    fetchMaticPrice() // Fetch the initial price

    const interval = setInterval(() => {
      fetchMaticPrice() // Fetch every 10 seconds for example
    }, 10000)

    return () => clearInterval(interval) // Clear the interval when the component unmounts
  }, [])

  const fetchMaticPrice = async () => {
    try {
      const response = await fetch(
        'https://api.coingecko.com/api/v3/simple/price?ids=matic-network&vs_currencies=usd',
      )
      const data = await response.json()
      setMaticPriceInUSD(data['matic-network'].usd)
    } catch (error) {
      console.error('Failed to fetch Matic price:', error)
    }
  }

  // const convertMaticToUSD = (maticAmount) => {
  //     return maticPriceInUSD ? (maticAmount * maticPriceInUSD).toFixed(2) : 0; // 2 decimal places
  // };

  return { maticPriceInUSD }
}
